/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonStratCommentInfo
 */
export interface JsonStratCommentInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonStratCommentInfo
     */
    allowedActions?: Array<JsonStratCommentInfoAllowedActionsEnum>;
    /**
     * 
     * @type {string}
     * @memberof JsonStratCommentInfo
     */
    authorFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonStratCommentInfo
     */
    authorLastName?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratCommentInfo
     */
    commentId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratCommentInfo
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratCommentInfo
     */
    createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratCommentInfo
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratCommentInfo
     */
    onepagerId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratCommentInfo
     */
    status?: JsonStratCommentInfoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonStratCommentInfo
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratCommentInfo
     */
    updatedBy?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonStratCommentInfoAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonStratCommentInfoStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE'
}

export function JsonStratCommentInfoFromJSON(json: any): JsonStratCommentInfo {
    return JsonStratCommentInfoFromJSONTyped(json, false);
}

export function JsonStratCommentInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonStratCommentInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'authorFirstName': !exists(json, 'authorFirstName') ? undefined : json['authorFirstName'],
        'authorLastName': !exists(json, 'authorLastName') ? undefined : json['authorLastName'],
        'commentId': !exists(json, 'commentId') ? undefined : json['commentId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'onepagerId': !exists(json, 'onepagerId') ? undefined : json['onepagerId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function JsonStratCommentInfoToJSON(value?: JsonStratCommentInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'authorFirstName': value.authorFirstName,
        'authorLastName': value.authorLastName,
        'commentId': value.commentId,
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'description': value.description,
        'onepagerId': value.onepagerId,
        'status': value.status,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
    };
}

